/* Recherche instantanée Tendre Veilleuse (« Veille de nuit ») : panneau snippets/tv-search-panel.liquid,
   suggestions sections/tv-search-suggest.liquid, total des produits templates/search.tvcount.liquid. */
(function () {
  'use strict';

  var root = document.getElementById('tvSearch');
  if (!root) return;
  if (root.parentElement !== document.body) document.body.appendChild(root);

  var sheet = root.querySelector('.tvs-sheet');
  var input = root.querySelector('#tvsInput');
  var clearBtn = root.querySelector('.tvs-clear');
  var results = root.querySelector('#tvsResults');
  var idle = root.querySelector('.tvs-idle');
  var empty = root.querySelector('.tvs-empty');
  var emptyQ = root.querySelector('.tvs-empty__q');
  var found = root.querySelector('.tvs-found');
  var foundN = root.querySelector('.tvs-found__n');
  var foundQ = root.querySelector('.tvs-found__q');
  var foundSub = root.querySelector('.tvs-found__sub');
  var seg = root.querySelector('.tvs-seg');
  var cta = root.querySelector('.tvs-cta');
  var sav = root.querySelector('.tvs-sav');
  var status = root.querySelector('#tvsStatus');
  var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  var SAV = [
    ['suivi', /suivi|colis|ma commande|tracking|o[uù] est/],
    ['livraison', /livr|exp[ée]di|d[ée]lai|frais de port/],
    ['retour', /retour|rembours|[ée]chang|annul|garantie/],
    ['contact', /contact|sav|service client|aide|t[ée]l[ée]phone|mail/]
  ];

  var cache = {};
  var timer = null;
  var controller = null;
  var lastTerm = '';
  var lastFocus = null;
  var pushed = false;
  var noResultSent = {};

  function track(name, params) {
    if (typeof window.gtag === 'function') window.gtag('event', name, params);
  }

  function open(value) {
    if (!root.hidden) return;
    lastFocus = document.activeElement;
    root.hidden = false;
    document.body.classList.add('tvs-lock');
    if (typeof value === 'string' && value !== input.value) input.value = value;
    // Focus synchrone, dans le geste : c'est ce qui ouvre le clavier sur iOS.
    input.focus({ preventScroll: true });
    requestAnimationFrame(function () { root.classList.add('is-open'); });
    // Sur tactile, le bouton retour ferme le panneau au lieu de quitter la page.
    if (window.matchMedia('(pointer: coarse)').matches) {
      try { history.pushState({ tvs: 1 }, ''); pushed = true; } catch (e) { pushed = false; }
    }
    update();
  }

  function close(fromHistory) {
    if (root.hidden) return;
    root.classList.remove('is-open');
    document.body.classList.remove('tvs-lock');
    var done = function () { root.hidden = true; };
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) done();
    else setTimeout(done, 240);
    if (pushed && !fromHistory) { pushed = false; history.back(); }
    pushed = false;
    if (lastFocus && lastFocus.focus && !lastFocus.classList.contains('search-input')) {
      lastFocus.focus({ preventScroll: true });
    }
  }

  function showSav(q) {
    var any = false;
    SAV.forEach(function (rule) {
      var link = sav.querySelector('[data-tvs-sav="' + rule[0] + '"]');
      var on = !!q && rule[1].test(q);
      link.hidden = !on;
      if (on) any = true;
    });
    sav.hidden = !any;
  }

  function esc(t) {
    return t.replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }

  function highlight(scope, q) {
    var words = q.toLowerCase().split(/\s+/).filter(function (w) { return w.length > 1; });
    scope.querySelectorAll('.tvs-card__t').forEach(function (el) {
      var text = el.textContent, low = text.toLowerCase();
      for (var i = 0; i < words.length; i++) {
        var at = low.indexOf(words[i]);
        if (at > -1) {
          el.innerHTML = esc(text.slice(0, at)) + '<mark>' + esc(text.slice(at, at + words[i].length)) + '</mark>' + esc(text.slice(at + words[i].length));
          return;
        }
      }
    });
  }

  function plural(n, one, many) { return n + ' ' + (n > 1 ? many : one); }

  function render(q, html, total) {
    var tpl = document.createElement('template');
    tpl.innerHTML = html;
    var res = tpl.content.querySelector('.tvs-res');
    var c = res ? res.querySelector('.tvs-count').dataset : { p: 0, c: 0, a: 0 };
    var p = +c.p, nc = Math.min(+c.c, 3), na = Math.min(+c.a, 3);
    var any = p + nc + na > 0;

    idle.hidden = true;
    // Une demande SAV reconnue affiche ses raccourcis : pas de « rien trouvé » par-dessus.
    empty.hidden = any || !sav.hidden;
    found.hidden = !any;
    emptyQ.textContent = q;

    if (!any) {
      results.innerHTML = '';
      status.textContent = 'Aucun résultat pour ' + q;
      if (!noResultSent[q]) { noResultSent[q] = true; track('search_no_result', { search_term: q, source: 'instant' }); }
      return;
    }

    highlight(res, q);
    nameBlocks(res);
    results.innerHTML = '';
    results.appendChild(res);

    var n = total || p;
    var side = [];
    if (nc) side.push(plural(nc, 'univers', 'univers'));
    if (na) side.push(plural(na, 'guide de Lumie', 'guides de Lumie'));
    foundN.textContent = p ? plural(n, 'lueur', 'lueurs') : 'Des pistes';
    foundQ.textContent = q;
    foundSub.textContent = side.length ? (p ? 'et ' : '') + side.join(', ') : '';
    seg.hidden = !(p && side.length);
    setFilter('');
    requestAnimationFrame(movePill);
    cta.hidden = !p;
    cta.href = base + 'search?q=' + encodeURIComponent(q) + '&type=product';
    cta.textContent = n > 1 ? 'Voir les ' + n + ' produits pour « ' + q + ' »' : 'Voir le produit';
    status.textContent = plural(n, 'produit', 'produits') + (side.length ? ', ' + side.join(', ') : '') + ' pour ' + q;
  }

  var pill = seg.querySelector('.tvs-seg__pill');
  var calm = window.matchMedia('(prefers-reduced-motion: reduce)');

  function movePill() {
    var on = seg.querySelector('[aria-pressed="true"]');
    if (!on || !on.offsetWidth) return;
    pill.style.width = on.offsetWidth + 'px';
    pill.style.transform = 'translateX(' + on.offsetLeft + 'px)';
    seg.classList.add('is-ready');
  }

  // Chaque carte et chaque bloc porte un nom : la View Transitions API anime le passage
  // d'une mise en page à l'autre (les produits s'élargissent, l'autre zone s'efface).
  function nameBlocks(res) {
    res.querySelectorAll('.tvs-card, .tvs-res__side > div').forEach(function (el, i) {
      el.style.viewTransitionName = 'tvs-' + i;
    });
  }

  function setFilter(f, animate) {
    var res = results.querySelector('.tvs-res');
    var apply = function () { if (res) res.setAttribute('data-f', f); };
    seg.querySelectorAll('button').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.f === f)); });
    movePill();
    if (animate && res && document.startViewTransition && !calm.matches) document.startViewTransition(apply);
    else apply();
  }

  function get(url) {
    return fetch(url, controller ? { signal: controller.signal } : {})
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); });
  }

  function fetchSuggest(q) {
    if (cache[q]) { render(q, cache[q][0], cache[q][1]); return; }
    if (controller) controller.abort();
    controller = 'AbortController' in window ? new AbortController() : null;
    root.classList.add('is-loading');

    var params = new URLSearchParams({
      q: q,
      section_id: 'tv-search-suggest',
      'resources[type]': 'product,collection,article',
      'resources[limit]': '8',
      'resources[limit_scope]': 'each',
      'resources[options][unavailable_products]': 'last'
    });
    var count = new URLSearchParams({ q: q, type: 'product', view: 'tvcount' });

    Promise.all([
      get(base + 'search/suggest?' + params.toString()),
      get(base + 'search?' + count.toString()).then(function (t) { return parseInt(t, 10) || 0; }, function () { return 0; })
    ])
      .then(function (r) {
        cache[q] = r;
        if (input.value.trim() === q) render(q, r[0], r[1]);
      })
      .catch(function () {})
      .then(function () { if (input.value.trim() === q) root.classList.remove('is-loading'); });
  }

  function update() {
    var q = input.value.trim();
    clearBtn.hidden = !input.value;
    showSav(q.toLowerCase());
    clearTimeout(timer);
    if (!q) {
      if (controller) controller.abort();
      root.classList.remove('is-loading');
      results.innerHTML = '';
      empty.hidden = true;
      found.hidden = true;
      idle.hidden = false;
      status.textContent = '';
      lastTerm = '';
      return;
    }
    if (q === lastTerm) return;
    lastTerm = q;
    timer = setTimeout(function () { fetchSuggest(q); }, cache[q] ? 0 : 160);
  }

  function focusables() {
    return Array.prototype.filter.call(
      sheet.querySelectorAll('a[href], button:not([hidden]), input:not([type="hidden"])'),
      function (el) { return el.offsetParent !== null; }
    );
  }

  function moveFocus(step) {
    var list = Array.prototype.filter.call(
      root.querySelectorAll('.tvs-body a[href]'),
      function (el) { return el.offsetParent !== null; }
    );
    if (!list.length) return;
    var i = list.indexOf(document.activeElement);
    if (i === -1) { if (step > 0) list[0].focus(); return; }
    var next = i + step;
    if (next < 0) input.focus();
    else if (next < list.length) list[next].focus();
  }

  input.addEventListener('input', update);
  clearBtn.addEventListener('click', function () { input.value = ''; update(); input.focus(); });
  seg.addEventListener('click', function (e) {
    var b = e.target.closest('button');
    if (b && b.getAttribute('aria-pressed') !== 'true') setFilter(b.dataset.f, true);
  });

  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-tvs-close]')) { close(); return; }
    var item = e.target.closest('[data-tvs-item], [data-tvs-sav]');
    if (item) {
      track('search_suggest_click', {
        search_term: input.value.trim(),
        item_type: item.getAttribute('data-tvs-item') || 'sav',
        link_url: item.getAttribute('href')
      });
    }
  });

  root.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key === 'ArrowDown') { e.preventDefault(); moveFocus(1); return; }
    if (e.key === 'ArrowUp' && document.activeElement !== input) { e.preventDefault(); moveFocus(-1); return; }
    if (e.key === 'Tab') {
      var list = focusables();
      if (!list.length) return;
      var first = list[0], last = list[list.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  window.addEventListener('resize', movePill, { passive: true });
  window.addEventListener('popstate', function () { if (!root.hidden) { pushed = false; close(true); } });

  // Déclencheurs : loupe mobile, champ du header desktop, tout [data-tvs-open].
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.mobile-search-btn, [data-tvs-open]');
    if (!trigger) return;
    e.preventDefault();
    open();
  });

  var headerInput = document.querySelector('.header-section .search-form .search-input');
  if (headerInput) {
    headerInput.addEventListener('focus', function () {
      var v = headerInput.value;
      headerInput.blur();
      open(v);
    });
  }
})();
